import { render, staticRenderFns } from "./CollapsibleParagraph.vue?vue&type=template&id=35cad82e&scoped=true&"
import script from "./CollapsibleParagraph.vue?vue&type=script&lang=js&"
export * from "./CollapsibleParagraph.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleParagraph.vue?vue&type=style&index=0&id=35cad82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cad82e",
  null
  
)

export default component.exports